export default [
  'Provided Below',
  'Call Office',
  'Call Patient',
  'No Insurance'
].reduce((a, c) => {
  a[c.toLowerCase().replace(/\s/g, '')] = c
  return a
}, {})
